import { onBeforeUnmount, onMounted, ref, shallowRef } from 'vue';
import * as echarts from 'echarts';
function useEChart() {
    const chartObj = shallowRef();
    const chartContainer = ref();
    const setChartOption = (chartOption) => {
        var _a;
        (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.setOption(chartOption);
    };
    const resizeChart = () => {
        var _a;
        (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.resize();
    };
    const clearChart = () => {
        var _a;
        (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.clear();
    };
    const getChartRect = () => {
        var _a, _b;
        return {
            width: (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.getWidth(),
            height: (_b = chartObj.value) === null || _b === void 0 ? void 0 : _b.getHeight(),
        };
    };
    const addChartEvent = (name, callback) => {
        var _a;
        (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.on(name, callback);
        return () => {
            var _a;
            (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.off(name, callback);
        };
    };
    const dispatchAction = (payload) => {
        var _a;
        (_a = chartObj.value) === null || _a === void 0 ? void 0 : _a.dispatchAction(payload);
    };
    onMounted(() => {
        chartObj.value = echarts.init(chartContainer.value); // 初始化一次
        window.addEventListener('resize', resizeChart);
    });
    onBeforeUnmount(() => {
        window.removeEventListener('resize', resizeChart);
    });
    return {
        setChartOption,
        resizeChart,
        clearChart,
        getChartRect,
        addChartEvent,
        chartContainer,
        dispatchAction,
    };
}
export { useEChart };
